import { useState } from "react";

export const ProductState = () => {
	const [loader, setLoader] = useState({ previewLoader: false, customizationLoader: false })
	const [openSidebar, setOpenSidebar] = useState({ siteColors: false, siteIdentity: false })
	const [openSketchPicker, setOpenSketchPicker] = useState({ primaryColors: false, headerBgColor: false })
	const [customizationData, setCustomizationData] = useState({
/* 		primaryColor: '#B6174B',
		secondaryColor: '#B6174B26',
		siteTitle: 'Dadas',
		headerBgColor: '#E34935',
		logo: { value: "", stat: false, msg: "Logo is required!", objectImg: "", b64Img: "", link: "" }, */
	})
	const [websiteStatus, setWebsiteStatus] = useState(0)
	const [dfltData, setDfltData] = useState([
		/* { 
			id: 1,
			name: "Lecon Belly", 
			price: 210.00, 
			type: '1pc',
			qty: 2, 
			selected: false, 
			shippingFee: 49.00,
			main_type: 1, 
			sub_type: 1,
			image: "https://pofsis-repo.s3.amazonaws.com/pofsis-tool-upload/public/heroesrelationshipcentre/setup-realproperty-mypropertylisting/0513f62c-d5e5-4c6a-8e1d-ed718ab32457_lechonbelly.png" 
		}*/
	])
	const [staticCart, setStaticCart] = useState({ cart: [], total: 0, shippingFee: 0 })
	const [myOrders, setMyOrders] = useState({ type: 1, sub_type: 1, filtered: [] })
	const [error, setError] = useState({ field: false, image: false })
	const [confirmation, setConfirmation] = useState({ modal: false, type: 1, submitting: false, webId: '', successSnackbar: false })
	const [companyPromo, setCompanyPromo] = useState([])

	return {
		loader: { data: loader, set: setLoader },
		openSidebar: { data: openSidebar, set: setOpenSidebar },
		openSketchPicker: { data: openSketchPicker, set: setOpenSketchPicker },
		customizationData: { data: customizationData, set: setCustomizationData },
		websiteStatus: { data: websiteStatus, set: setWebsiteStatus },
		dfltData: { data: dfltData, set: setDfltData },
		staticCart: { data: staticCart, set: setStaticCart },
		myOrders: { data: myOrders, set: setMyOrders },
		error: { data: error, set: setError },
		confirmation: { data: confirmation, set: setConfirmation },
		companyPromo: { data: companyPromo, set: setCompanyPromo },
	}
}